export const POST_CURBSIDE_CHECKIN_INFO = 'POST_CURBSIDE_CHECKIN_INFO';
export const POST_CURBSIDE_CHECKIN_INFO_SUCCESS = 'POST_CURBSIDE_CHECKIN_INFO_SUCCESS';
export const POST_CURBSIDE_CHECKIN_INFO_ERROR = 'POST_CURBSIDE_CHECKIN_INFO_ERROR';
export const GET_CURBSIDE_CHECKIN_INFO_SUCCESS = 'GET_CURBSIDE_CHECKIN_INFO_SUCCESS';
export const GET_CURBSIDE_CHECKIN_INFO_ERROR = 'GET_CURBSIDE_CHECKIN_INFO_ERROR';
export const POLL_GET_CURBSIDE_CHECKIN_INFO = 'POLL_GET_CURBSIDE_CHECKIN_INFO';
export const STOP_POLLING_GET_CURBSIDE_CHECKIN_INFO = 'STOP_POLLING_GET_CURBSIDE_CHECKIN_INFO';
export const PATCH_CANCEL_CURBSIDE = 'PATCH_CANCEL_CURBSIDE';
export const PATCH_CANCEL_CURBSIDE_SUCCESS = 'PATCH_CANCEL_CURBSIDE_SUCCESS';
export const PATCH_CANCEL_CURBSIDE_ERROR = 'PATCH_CANCEL_CURBSIDE_ERROR';
export const GET_CURBSIDE_PICKUP_ORDER_INFO = 'GET_CURBSIDE_PICKUP_ORDER_INFO';
export const GET_CURBSIDE_PICKUP_ORDER_INFO_SUCCESS = 'GET_CURBSIDE_PICKUP_ORDER_INFO_SUCCESS';
export const GET_CURBSIDE_PICKUP_ORDER_INFO_ERROR = 'GET_CURBSIDE_PICKUP_ORDER_INFO_ERROR';
export const GET_CURBSIDE_PICKUP_STORE_INFO = 'GET_CURBSIDE_PICKUP_STORE_INFO';
export const GET_CURBSIDE_PICKUP_STORE_INFO_SUCCESS = 'GET_CURBSIDE_PICKUP_STORE_INFO_SUCCESS';
export const GET_CURBSIDE_PICKUP_STORE_INFO_ERROR = 'GET_CURBSIDE_PICKUP_STORE_INFO_ERROR';
export const CURBSIDE_PICKUP_LOAD_ANALYTICS_ACTION = 'CURBSIDE_PICKUP_LOAD_ANALYTICS_ACTION';
export const CURBSIDE_EVENTS_ANALYTICS_ACTION = 'CURBSIDE_EVENTS_ANALYTICS_ACTION';
export const CURBSIDE_STATUS_INFO_ACTION = 'CURBSIDE_STATUS_INFO_ACTION';
export const GET_CURBSIDE_CHECKIN_INFO_SERVICE_DOWN = 'GET_CURBSIDE_CHECKIN_INFO_SERVICE_DOWN';
export const GET_CURBSIDE_CHECKIN_INFO_SERVICE_UP = 'GET_CURBSIDE_CHECKIN_INFO_SERVICE_UP';
export const RESET_CURBSIDE_CHECKIN_INFO = 'RESET_CURBSIDE_CHECKIN_INFO';
export const GET_INSIDE_STORE = 'GET_INSIDE_STORE';
